// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1gTau","name":"ConsentHeader_name__2ui4-","birthday":"ConsentHeader_birthday__3NyUN","skeleton":"ConsentHeader_skeleton__1rDzM"};